import React, { Component } from "react";
import jwt from "../../utils/jwt";
import { formatDate, formatTime } from "../../utils/common";
import "./tripTable.scss";
import { Fetch } from "../../utils/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PopUpModal from "../Layout/popUpModal";
import AssignDriverForm from "../assignDriverForm/assignDriverForm";
import MidScreenPopUp from "../Layout/midScreenPopUp";
import { tracerUrl } from "../../config";

const TRIP_STATUS_LABELS = {
  ACTIVE: "Active",
  ONTRIP: "On Trip",
  COMPLETED: "Completed",
  INACTIVE: "Inactive",
};
// Statuses set once the driver starts the trip from the Driver App
const STARTED_TRIP_STATUSES = ["ONTRIP", "COMPLETED"];

class TripTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedRow: null,
      showPopUp: false,
      rcNumber: "",
      driverMobileNo: "",
      driverName: "",
      showAssignDriverPopUp: false,
      isDriverAssigned: false,
      assignedTripDetails: {},
      tooltipVisible: false,
      tooltipPosition: { top: 0, left: 0 },
      tooltipData: {},
      coreServiceNames: {},
      expandedBookings: {},
      isTrackBusLoading: false,
      loggedInMobileNo: props.loggedInMobileNo,
    };
  }

  componentDidMount() {
    toast.configure();
    this.prepareBookingMaps(this.props.trips);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.trips !== this.props.trips &&
      this.props.trips &&
      this.props.trips.length > 0
    ) {
      this.prepareBookingMaps(this.props.trips);
    }
  }

  prepareBookingMaps = (trips) => {
    const marshalIdToBookingIdMap = {}; // { tripId: { marshalId: [bookings] } }
    const bookingIdMap = {};
    const tripIdToMarshalIdMap = {};

    if (trips && trips.length > 0) {
      trips.forEach((trip) => {
        const tripId = trip && trip.id;
        if (!tripId) {
          return;
        }
        const toCityId = trip?.bookings?.[0]?.toCityId;

        const tripMarshalMap = {};
        const marshalIdsInThisTrip = new Set();

        if (trip.boaredCoreBooking && trip.boaredCoreBooking.length > 0) {
          trip.boaredCoreBooking.forEach((boardedBooking) => {
            const boardedLegMarshalDetails =
              boardedBooking && boardedBooking.boardedLegMarshalDetails;
            const bookingId = boardedBooking && boardedBooking.bookingId;

            if (
              boardedLegMarshalDetails &&
              boardedLegMarshalDetails.busHostId &&
              bookingId
            ) {
              const marshalId = boardedLegMarshalDetails.busHostId;

              if (!tripMarshalMap[marshalId]) {
                tripMarshalMap[marshalId] = [];
              }

              tripMarshalMap[marshalId].push({
                toCityId,
                bookingId,
                boardedLegMarshalDetails,
              });

              marshalIdsInThisTrip.add(marshalId);
            }
          });
        }

        marshalIdToBookingIdMap[tripId] = tripMarshalMap;

        if (marshalIdsInThisTrip.size > 0) {
          tripIdToMarshalIdMap[tripId] = Array.from(marshalIdsInThisTrip);
        }

        if (trip.bookings && trip.bookings.length > 0) {
          trip.bookings.forEach((booking) => {
            if (booking && booking._id) {
              bookingIdMap[booking._id] = booking;
            }
          });
        }
      });
    }

    this.setState({
      marshalIdToBookingIdMap,
      bookingIdMap,
      tripIdToMarshalIdMap,
    });
  };

  toggleRow = (id) => {
    this.setState((prevState) => ({
      expandedRow: prevState.expandedRow === id ? null : id,
    }));
  };

  handleTooltipHover = (event, data) => {
    const { top, left, height } = event.target.getBoundingClientRect();

    this.setState({
      tooltipVisible: true,
      tooltipPosition: {
        top: top + height + 10 + window.scrollY,
        left: left - 240,
      },
      tooltipData: data,
    });
  };

  handleTooltipClick = (event, data) => {
    const { top, left, height } = event.target.getBoundingClientRect();

    this.setState((prevState) => ({
      tooltipVisible: !prevState.tooltipVisible,
      tooltipPosition: {
        top: top + height + 10 + window.scrollY,
        left: left - 240,
      },
      tooltipData: data,
    }));
  };

  hideTooltip = () => {
    this.setState({ tooltipVisible: false });
  };
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  handleDial = async (mobileNo) => {
    if (this.state.isDialDisabled) return;

    this.setState({ isDialDisabled: true });
    setTimeout(() => {
      this.setState({ isDialDisabled: false });
    }, 5000);

    const token = localStorage.getItem("idToken");
    const decodedToken = jwt.decode(token);
    const userMobileNo = decodedToken.mobileNo;

    const url = "/cabOperator/clickToCall";
    const options = {
      method: "post",
      data: {
        caller: userMobileNo,
        receiver: mobileNo,
      },
    };

    const response = await Fetch(url, options);
    if (response === "call success") {
      toast.success(
        "Call initiated successfully! You will receive a connecting call soon",
      );
    }
  };

  openAssignDriverPopUp = async (assignedDriverDetails, index) => {
    if (index !== undefined && index !== null && index >= 0) {
      const { trips } = this.props;
      this.setState({
        assignedTripDetails: trips[index],
        rcNumber: trips[index].rcNumber,
        driverMobileNo: trips[index].driverMobileNo,
        driverName: trips[index].driverName,
      });
    }
    this.setState((prevState) => ({
      showAssignDriverPopUp: !prevState.showAssignDriverPopUp,
    }));
    if (assignedDriverDetails) {
      this.setState({
        rcNumber: assignedDriverDetails.vehicleDetails.rc,
        driverMobileNo: assignedDriverDetails.driverDetails.mobileNo,
        driverName: assignedDriverDetails.driverDetails.name,
      });
    }
  };

  fetchCoreService = async (connectingBookingCode) => {
    const url = `/cabOperator/getServiceName/${connectingBookingCode}`;

    const options = {
      method: "get",
    };
    const response = await Fetch(url, options);
    if (response) {
      this.setState((prevState) => ({
        coreServiceNames: {
          ...prevState.coreServiceNames,
          [connectingBookingCode]: {
            connectingBookingServiceName: response.connectingBookingServiceName,
            coreLegPnr: response.coreLegPnr,
          },
        },
      }));
    } else {
      return [];
    }
  };

  fetchCoreTrip = async (bookingId) => {
    const url = `/cabOperator/coreTrip/${bookingId}`;

    const options = {
      method: "get",
    };
    const response = await Fetch(url, options);
    if (response) {
      // add the tripIdToMarshalIdMap with the new core trip details
      this.setState((prevState) => {
        const updatedTripIdToMarshalIdMap = {
          ...prevState.tripIdToMarshalIdMap,
        };
        const updatedMarshalIdToBookingIdMap = {
          ...prevState.marshalIdToBookingIdMap,
        };

        if (response && response.boaredCoreBooking) {
          response.boaredCoreBooking.forEach((boardedBooking) => {
            const boardedLegMarshalDetails =
              boardedBooking && boardedBooking.boardedLegMarshalDetails;
            const bookingId = boardedBooking && boardedBooking.bookingId;
            const tripId = response.id;

            if (
              boardedLegMarshalDetails &&
              boardedLegMarshalDetails.busHostId &&
              bookingId
            ) {
              const marshalId = boardedLegMarshalDetails.busHostId;

              if (!updatedTripIdToMarshalIdMap[tripId]) {
                updatedTripIdToMarshalIdMap[tripId] = new Set();
              }
              updatedTripIdToMarshalIdMap[tripId].add(marshalId);

              if (!updatedMarshalIdToBookingIdMap[tripId]) {
                updatedMarshalIdToBookingIdMap[tripId] = {};
              }
              if (!updatedMarshalIdToBookingIdMap[tripId][marshalId]) {
                updatedMarshalIdToBookingIdMap[tripId][marshalId] = [];
              }
              updatedMarshalIdToBookingIdMap[tripId][marshalId].push({
                bookingId,
                boardedLegMarshalDetails,
              });
            }
          });
        }

        return {
          tripIdToMarshalIdMap: Object.fromEntries(
            Object.entries(updatedTripIdToMarshalIdMap).map(([key, value]) => [
              key,
              Array.from(value),
            ]),
          ),
          marshalIdToBookingIdMap: updatedMarshalIdToBookingIdMap,
        };
      });

      // this.setState((prevState) => ({
      //   coreServiceNames: {
      //     ...prevState.coreServiceNames,
      //     [bookingId]: response,
      //   },
      // }));
    } else {
      return [];
    }
  };

  toggleDetails = async (connectingBookingCode) => {
    this.setState((prev) => {
      const isExpanded = prev.expandedBookings[connectingBookingCode];

      return {
        expandedBookings: {
          ...prev.expandedBookings,
          [connectingBookingCode]: !isExpanded,
        },
      };
    });

    if (!this.state.coreServiceNames[connectingBookingCode]) {
      await this.fetchCoreService(connectingBookingCode);
    }
  };

  togglePopUp = async (isSuccessFul) => {
    this.setState((prevState) => ({
      showPopUp: !prevState.showPopUp,
      isDriverAssigned: isSuccessFul,
    }));
    if (isSuccessFul) {
      await this.props.refreshTripsData();
    }
  };

  fetchCoreTrip = async (connectingBookingCode, cabServiceType) => {
    const url = `/cabOperator/tripDetails/${connectingBookingCode}/${cabServiceType}`;

    const options = {
      method: "get",
    };
    const response = await Fetch(url, options);
    if (response) {
      return response;
    } else {
      return [];
    }
  };

  handleTrackBusClick = async (bookingsWithMarshal) => {
    if (this.state.isTrackBusLoading) return; // prevent double click

    this.setState({ isTrackBusLoading: true });
    try {
      const bookingDetailsForTrack = bookingsWithMarshal;

      const trip = await this.fetchCoreTrip(
        bookingDetailsForTrack.connectingBookingCode,
        bookingDetailsForTrack.cabServiceType,
      );
      let cityId = null;
      if (bookingDetailsForTrack.cabServiceType === "FIRSTMILE") {
        cityId = bookingDetailsForTrack.toCityId;
      } else if (bookingDetailsForTrack.cabServiceType === "LASTMILE") {
        cityId = bookingDetailsForTrack.fromCityId;
      }

      let url = `${tracerUrl}cabsTracking/${trip}/${cityId}`;
      this.props.openTrackModal(url, "Track Bus");
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ isTrackBusLoading: false });
    }
  };

  handleTrackCabClick = (trip) => {
    this.props.openTrackModal(`${tracerUrl}cab-track/${trip.id}`, "Track Cab");
  };

  renderTrackCab = (trip) => {
    if (trip.status === "ONTRIP") {
      return (
        <button
          className="trackCabBtn"
          onClick={() => this.handleTrackCabClick(trip)}
        >
          Show
        </button>
      );
    }
    return (
      <button className="trackCabBtn" disabled>
        {trip.status === "COMPLETED" ? "Completed" : "Not started"}
      </button>
    );
  };

  render() {
    const { trips } = this.props;
    const {
      expandedRow,
      showAssignDriverPopUp,
      driverMobileNo,
      driverName,
      rcNumber,
      assignedTripDetails,
      showPopUp,
      isDriverAssigned,
      tooltipData,
      tooltipVisible,
      marshalIdToBookingIdMap,
      bookingIdMap,
      tripIdToMarshalIdMap,
      coreServiceNames,
      expandedBookings,
      isTrackBusLoading,
    } = this.state;
    return (
      <>
        {showAssignDriverPopUp ? (
          <PopUpModal
            isOpen={showAssignDriverPopUp}
            onClose={this.openAssignDriverPopUp}
            title="Assign Driver"
            width="400px"
          >
            <AssignDriverForm
              loggedInMobileNo={this.state.loggedInMobileNo}
              tripData={assignedTripDetails}
              onCloseDrawer={this.openAssignDriverPopUp}
              togglePopUp={this.togglePopUp}
              driverMobileNo={driverMobileNo}
              driverName={driverName}
              rcNumber={rcNumber}
            />
          </PopUpModal>
        ) : null}

        {showPopUp && isDriverAssigned ? (
          <MidScreenPopUp
            imageUrl="https://d1flzashw70bti.cloudfront.net/original/images/optdash/popup/greentick.svg"
            text="Assignment Successful"
            subText="Trip has been successfully assigned to driver."
            buttonText="Ok"
            onClose={this.togglePopUp}
          />
        ) : showPopUp && !isDriverAssigned ? (
          <MidScreenPopUp
            imageUrl="https://d1flzashw70bti.cloudfront.net/original/images/optdash/crisis.svg"
            text="Assignment Failed"
            subText="Trip could not be assigned to driver."
            buttonText="Ok"
            onClose={this.togglePopUp}
          />
        ) : null}

        {tooltipVisible && (
          <div
            className="tooltipBox"
            style={{
              position: "absolute",
              top: this.state.tooltipPosition.top,
              left: this.state.tooltipPosition.left,
            }}
          >
            <div className="tooltipRow">
              <span>Rc: {tooltipData.value1}</span>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/whitecopyicon.svg"
                alt="copy"
                onClick={() => this.copyToClipboard(tooltipData.value1)}
              />
            </div>
            <div className="tooltipRow">
              <span>Mobile: {tooltipData.value2}</span>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/whitecopyicon.svg"
                alt="copy"
                onClick={() => this.copyToClipboard(tooltipData.value2)}
              />
            </div>
            <div className="tooltipRow">
              <span>Name: {tooltipData.value3}</span>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/whitecopyicon.svg"
                alt="copy"
                onClick={() => this.copyToClipboard(tooltipData.value3)}
              />
            </div>
          </div>
        )}

        <div className="tripTableContainer" onClick={() => this.hideTooltip()}>
          <table className="tripTable">
            <thead>
              <tr>
                <th>
                  <div>Route</div>
                </th>
                <th>
                  <div className="coloumnTitle">Trip ID</div>
                </th>
                <th>
                  <div className="coloumnTitle">Start Time & Date</div>
                </th>
                <th>
                  <div className="coloumnTitle">Bookings</div>
                </th>
                <th>
                  <div className="coloumnTitle">Marshal</div>
                </th>
                <th>
                  <div className="coloumnTitle">Asset Type</div>
                </th>
                <th>
                  <div className="coloumnTitle">Status</div>
                </th>
                <th>
                  <div className="coloumnTitle">Assign</div>
                </th>
                <th>
                  <div className="coloumnTitle">Track Cab</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {trips.map((trip, index) => (
                <React.Fragment key={trip.id}>
                  <tr>
                    <td className="fromAndTo">{`${trip.from} - ${trip.to}`}</td>
                    <td className="tripId">
                      <span className="code">{trip.groupCode}</span>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                        alt="copy"
                        className="copyIcon"
                        onClick={() => this.copyToClipboard(trip.groupCode)}
                      />
                    </td>
                    <td>
                      <div className="timeAndDate">
                        <span className="time">
                          {formatTime(trip.startTime, "h:mm A")}
                        </span>
                        <span className="date">
                          {formatDate(trip.startTime, "D MMM YYYY")}
                        </span>
                      </div>
                    </td>
                    <td className="details">
                      <span className="noOfBookingsText">
                        {
                          trip.bookings.filter(
                            (booking) => booking.status === "CONFIRMED",
                          ).length
                        }
                      </span>
                      <button
                        className="detailsBtn"
                        onClick={() => this.toggleRow(trip.id)}
                      >
                        Details{" "}
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/caret-down1.svg"
                          alt="dropdown"
                          style={
                            expandedRow === trip.id
                              ? { transform: "rotate(180deg)" }
                              : null
                          }
                        />
                      </button>
                    </td>
                    <td className="marshalInfo">
                      <div className="viewDetails">
                        {tripIdToMarshalIdMap &&
                        marshalIdToBookingIdMap &&
                        tripIdToMarshalIdMap[trip.id] &&
                        marshalIdToBookingIdMap[trip.id]
                          ? (() => {
                              const marshalNames = tripIdToMarshalIdMap[trip.id]
                                .map((marshalId) => {
                                  const marshalDetails =
                                    marshalIdToBookingIdMap[trip.id]?.[
                                      marshalId
                                    ]?.[0]?.boardedLegMarshalDetails;
                                  return marshalDetails?.name || null;
                                })
                                .filter(Boolean)
                                .slice(0, 2); // show max 2 names

                              return marshalNames.length > 0
                                ? marshalNames.map((name, idx) => (
                                    <div key={idx}>{name}</div>
                                  ))
                                : "N.A";
                            })()
                          : "N.A"}
                      </div>
                    </td>
                    <td>
                      <div className="cellConainer">{trip.seater || "-"}</div>
                    </td>
                    <td>
                      <div className="cellConainer">
                        <span
                          className={`tripStatus ${(trip.status || "").toLowerCase()}`}
                        >
                          {TRIP_STATUS_LABELS[trip.status] || trip.status || "-"}
                        </span>
                      </div>
                    </td>
                    <td>
                      {trip.driverMobileNo ? (
                        <div className="assigned">
                          <div className="textWrapper">
                            <img
                              src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/greenTick.svg"
                              alt="assigned"
                              className="greenTick"
                            />
                            <span>Assigned</span>
                            <img
                              src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/infoicon.svg"
                              alt="assigned info"
                              className="toolTipIcon"
                              onMouseEnter={(e) =>
                                this.handleTooltipHover(e, {
                                  value1: trip.rcNumber,
                                  value2: trip.driverMobileNo,
                                  value3: trip.driverName,
                                })
                              }
                              onClick={(e) =>
                                this.handleTooltipClick(e, {
                                  value1: trip.rcNumber,
                                  value2: trip.driverMobileNo,
                                  value3: trip.driverName,
                                })
                              }
                            />
                          </div>
                          {trip.startTime + 14400000 > Date.now() &&
                          !STARTED_TRIP_STATUSES.includes(trip.status) ? (
                            <div
                              className="editView"
                              onClick={() =>
                                this.openAssignDriverPopUp(null, index)
                              }
                            >
                              Edit/View Details
                            </div>
                          ) : null}
                        </div>
                      ) : trip.startTime + 14400000 > Date.now() &&
                        !STARTED_TRIP_STATUSES.includes(trip.status) ? (
                        <div className="cellConainer">
                          <button
                            className="assignBtn"
                            onClick={() =>
                              this.openAssignDriverPopUp(null, index)
                            }
                          >
                            Assign
                          </button>
                        </div>
                      ) : (
                        <div className="cellConainer">
                          <span>N.A</span>
                        </div>
                      )}
                    </td>
                    <td>
                      <div className="cellConainer">
                        {this.renderTrackCab(trip)}
                      </div>
                    </td>
                  </tr>
                  {expandedRow === trip.id && (
                    <tr className="expandedRow">
                      <td colSpan="9">
                        <div className="bookingTiles">
                          {marshalIdToBookingIdMap?.[trip.id] &&
                          Object.keys(marshalIdToBookingIdMap[trip.id]).length >
                            0 ? (
                            <>
                              {tripIdToMarshalIdMap[trip.id].map(
                                (marshalId, marshalIndex) => {
                                  const bookingsWithMarshal =
                                    marshalIdToBookingIdMap[trip.id][marshalId];
                                  const bookingIds =
                                    bookingsWithMarshal[0]?.bookingId || "";
                                  const cityId =
                                    bookingsWithMarshal[0]?.toCityId || "";
                                  const marshalDetails =
                                    bookingsWithMarshal[0]
                                      ?.boardedLegMarshalDetails || {};

                                  return (
                                    <React.Fragment
                                      key={`marshal-${marshalId}`}
                                    >
                                      <div className="marshalHeader">
                                        <span className="marshalLabel">{`Marshal ${
                                          marshalIndex + 1
                                        }`}</span>
                                        <img
                                          className="icon"
                                          src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/person1.svg"
                                          alt="marshal-icon"
                                        />
                                        <span className="detailLabel">
                                          Name:
                                        </span>
                                        <span className="detailValue">
                                          {marshalDetails.name || "N.A"}
                                        </span>
                                        <img
                                          className="icon"
                                          src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/callicon.svg"
                                          alt="phone-icon"
                                        />
                                        <span className="detailLabel">
                                          Mobile No:
                                        </span>
                                        <span className="detailValue">
                                          {marshalDetails.mobileNo || "N.A"}
                                        </span>
                                      </div>

                                      {bookingsWithMarshal.map(
                                        ({ bookingId }, index) => {
                                          const booking =
                                            bookingIdMap[bookingId];
                                          if (!booking) return null;

                                          return (
                                            <div
                                              className="tileWrapper"
                                              key={`fallback-${booking._id}`}
                                            >
                                              <div className="bookingTile">
                                                <div className="index">
                                                  <span>{index + 1}</span>
                                                </div>
                                                <div className="name">
                                                  <span>{booking.name}</span>
                                                </div>
                                                <div className="seats">
                                                  Seats:{" "}
                                                  <strong>
                                                    {booking.noOfSeats}
                                                  </strong>
                                                </div>
                                                <div className="pickupAndDrop">
                                                  Pickup Station:{" "}
                                                  <strong>
                                                    {booking.fromStation.name}
                                                  </strong>
                                                  <br />
                                                  <div
                                                    style={{ marginTop: "8px" }}
                                                  ></div>
                                                  Drop Station:{" "}
                                                  <strong>
                                                    {booking.toStation.name}
                                                  </strong>
                                                </div>
                                                <div className="pickupAndDropTime">
                                                  Pickup Time:{" "}
                                                  <strong>
                                                    {formatTime(
                                                      booking.fromStationDate,
                                                      "h:mm A",
                                                    )}
                                                  </strong>
                                                  <br />
                                                  <div
                                                    style={{ marginTop: "8px" }}
                                                  ></div>
                                                  Drop Time:{" "}
                                                  <strong>
                                                    {formatTime(
                                                      booking.toStationDate,
                                                      "h:mm A",
                                                    )}
                                                  </strong>
                                                </div>
                                                 
                                                <div className="buttonContainer">
                                                  <div className="callBtnContainer">
                                                    {trip.startTime + 14400000 >
                                                      Date.now() && (
                                                      <div
                                                        className="callBtn"
                                                        onClick={() =>
                                                          this.handleDial(
                                                            booking.mobileNo,
                                                          )
                                                        }
                                                      >
                                                        <img
                                                          src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/callIcon.svg"
                                                          alt="call"
                                                        />
                                                        Call
                                                      </div>
                                                    )}
                                                  </div>
                                                  <div
                                                    className={`trackBus ${isTrackBusLoading ? "disabled" : ""}`}
                                                    onClick={() =>
                                                      this.handleTrackBusClick(
                                                        booking,
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      src="https://d1flzashw70bti.cloudfront.net/original/images/trackBus.svg"
                                                      alt="track"
                                                    />
                                                    <span>Track</span>
                                                  </div>
                                                  <div
                                                    className="serviceViewButton"
                                                    onClick={() =>
                                                      this.toggleDetails(
                                                        booking.connectingBookingCode,
                                                      )
                                                    }
                                                  >
                                                    <span>
                                                      {expandedBookings[
                                                        booking
                                                          .connectingBookingCode
                                                      ]
                                                        ? "Hide"
                                                        : "Details"}
                                                    </span>

                                                    <img
                                                      src={
                                                        expandedBookings[
                                                          booking
                                                            .connectingBookingCode
                                                        ]
                                                          ? "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrow.svg"
                                                          : "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrowView.svg"
                                                      }
                                                      alt="toggleArrow"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="expandedRow">
                                                {expandedBookings[
                                                  booking.connectingBookingCode
                                                ] &&
                                                  coreServiceNames[
                                                    booking
                                                      .connectingBookingCode
                                                  ] && (
                                                    <div className="items">
                                                      <div className="serviceNameDetails">
                                                        <span>
                                                          PNR:{" "}
                                                          <b>
                                                            {
                                                              coreServiceNames[
                                                                booking
                                                                  .connectingBookingCode
                                                              ].coreLegPnr
                                                            }
                                                          </b>
                                                        </span>
                                                        <img
                                                          src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                                                          alt="copy"
                                                          className="copyIcon"
                                                          onClick={() =>
                                                            this.copyToClipboard(
                                                              coreServiceNames[
                                                                booking
                                                                  .connectingBookingCode
                                                              ].coreLegPnr,
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                      <div className="serviceNameDetails">
                                                        <span>
                                                          Service:{" "}
                                                          <b>
                                                            {
                                                              coreServiceNames[
                                                                booking
                                                                  .connectingBookingCode
                                                              ]
                                                                .connectingBookingServiceName
                                                            }
                                                          </b>
                                                        </span>
                                                        <img
                                                          src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                                                          alt="copy"
                                                          className="copyIcon"
                                                          onClick={() =>
                                                            this.copyToClipboard(
                                                              coreServiceNames[
                                                                booking
                                                                  .connectingBookingCode
                                                              ]
                                                                .connectingBookingServiceName,
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          );
                                        },
                                      )}
                                    </React.Fragment>
                                  );
                                },
                              )}

                              {/* Unmapped bookings (no marshal assigned) */}
                              {trip.bookings
                                .filter(
                                  (booking) =>
                                    booking.status === "CONFIRMED" &&
                                    !tripIdToMarshalIdMap[trip.id]?.some(
                                      (marshalId) =>
                                        marshalIdToBookingIdMap[trip.id]?.[
                                          marshalId
                                        ]?.some(
                                          (entry) =>
                                            entry.bookingId === booking._id,
                                        ),
                                    ),
                                )
                                .map((booking, index) => (
                                  <React.Fragment
                                    key={`no-marshal-${booking._id}`}
                                  >
                                    <div className="marshalHeader">
                                      <span className="marshalLabel">
                                        Marshal
                                      </span>
                                      <img
                                        className="icon"
                                        src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/person1.svg"
                                        alt="marshal-icon"
                                      />
                                      <span className="detailLabel">Name:</span>
                                      <span className="detailValue">N.A</span>
                                      <img
                                        className="icon"
                                        src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/callicon.svg"
                                        alt="phone-icon"
                                      />
                                      <span className="detailLabel">
                                        Mobile No:
                                      </span>
                                      <span className="detailValue">N.A</span>
                                    </div>

                                    <div
                                      className="tileWrapper"
                                      key={`fallback-${booking._id}`}
                                    >
                                      <div className="bookingTile">
                                        <div className="index">
                                          <span>{index + 1}</span>
                                        </div>
                                        <div className="name">
                                          <span>{booking.name}</span>
                                        </div>
                                        <div className="seats">
                                          Seats:{" "}
                                          <strong>{booking.noOfSeats}</strong>
                                        </div>
                                        <div className="pickupAndDrop">
                                          Pickup Station:{" "}
                                          <strong>
                                            {booking.fromStation.name}
                                          </strong>
                                          <br />
                                          <div
                                            style={{ marginTop: "8px" }}
                                          ></div>
                                          Drop Station:{" "}
                                          <strong>
                                            {booking.toStation.name}
                                          </strong>
                                        </div>
                                        <div className="pickupAndDropTime">
                                          Pickup Time:{" "}
                                          <strong>
                                            {formatTime(
                                              booking.fromStationDate,
                                              "h:mm A",
                                            )}
                                          </strong>
                                          <br />
                                          <div
                                            style={{ marginTop: "8px" }}
                                          ></div>
                                          Drop Time:{" "}
                                          <strong>
                                            {formatTime(
                                              booking.toStationDate,
                                              "h:mm A",
                                            )}
                                          </strong>
                                        </div>
                                         
                                        <div className="buttonContainer">
                                          <div className="callBtnContainer">
                                            {trip.startTime + 14400000 >
                                              Date.now() && (
                                              <div
                                                className="callBtn"
                                                onClick={() =>
                                                  this.handleDial(
                                                    booking.mobileNo,
                                                  )
                                                }
                                              >
                                                <img
                                                  src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/callIcon.svg"
                                                  alt="call"
                                                />
                                                Call
                                              </div>
                                            )}
                                          </div>
                                          <div
                                            className={`trackBus ${isTrackBusLoading ? "disabled" : ""}`}
                                            onClick={() =>
                                              this.handleTrackBusClick(booking)
                                            }
                                          >
                                            <img
                                              src="https://d1flzashw70bti.cloudfront.net/original/images/trackBus.svg"
                                              alt="track"
                                            />
                                            <span>Track</span>
                                          </div>
                                          <div
                                            className="serviceViewButton"
                                            onClick={() =>
                                              this.toggleDetails(
                                                booking.connectingBookingCode,
                                              )
                                            }
                                          >
                                            <span>
                                              {expandedBookings[
                                                booking.connectingBookingCode
                                              ]
                                                ? "Hide"
                                                : "Details"}
                                            </span>

                                            <img
                                              src={
                                                expandedBookings[
                                                  booking.connectingBookingCode
                                                ]
                                                  ? "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrow.svg"
                                                  : "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrowView.svg"
                                              }
                                              alt="toggleArrow"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="expandedRow">
                                        {expandedBookings[
                                          booking.connectingBookingCode
                                        ] &&
                                          coreServiceNames[
                                            booking.connectingBookingCode
                                          ] && (
                                            <div className="items">
                                              <div className="serviceNameDetails">
                                                <span>
                                                  PNR:{" "}
                                                  <b>
                                                    {
                                                      coreServiceNames[
                                                        booking
                                                          .connectingBookingCode
                                                      ].coreLegPnr
                                                    }
                                                  </b>
                                                </span>
                                                <img
                                                  src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                                                  alt="copy"
                                                  className="copyIcon"
                                                  onClick={() =>
                                                    this.copyToClipboard(
                                                      coreServiceNames[
                                                        booking
                                                          .connectingBookingCode
                                                      ].coreLegPnr,
                                                    )
                                                  }
                                                />
                                              </div>
                                              <div className="serviceNameDetails">
                                                <span>
                                                  Service:{" "}
                                                  <b>
                                                    {
                                                      coreServiceNames[
                                                        booking
                                                          .connectingBookingCode
                                                      ]
                                                        .connectingBookingServiceName
                                                    }
                                                  </b>
                                                </span>
                                                <img
                                                  src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                                                  alt="copy"
                                                  className="copyIcon"
                                                  onClick={() =>
                                                    this.copyToClipboard(
                                                      coreServiceNames[
                                                        booking
                                                          .connectingBookingCode
                                                      ]
                                                        .connectingBookingServiceName,
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </React.Fragment>
                                ))}
                            </>
                          ) : (
                            // Fallback if no marshal mapping
                            <>
                              <div className="marshalHeader">
                                <span className="marshalLabel">Marshal</span>
                                <img
                                  className="icon"
                                  src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/person1.svg"
                                  alt="marshal-icon"
                                />
                                <span className="detailLabel">Name:</span>
                                <span className="detailValue">N.A</span>
                                <img
                                  className="icon"
                                  src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/callicon.svg"
                                  alt="phone-icon"
                                />
                                <span className="detailLabel">Mobile No:</span>
                                <span className="detailValue">N.A</span>
                              </div>

                              {trip.bookings
                                .filter(
                                  (booking) => booking.status === "CONFIRMED",
                                )
                                .map((booking, index) => (
                                  <div
                                    className="tileWrapper"
                                    key={`fallback-${booking._id}`}
                                  >
                                    <div className="bookingTile">
                                      <div className="index">
                                        <span>{index + 1}</span>
                                      </div>
                                      <div className="name">
                                        <span>{booking.name}</span>
                                      </div>
                                      <div className="seats">
                                        Seats:{" "}
                                        <strong>{booking.noOfSeats}</strong>
                                      </div>
                                      <div className="pickupAndDrop">
                                        Pickup Station:{" "}
                                        <strong>
                                          {booking.fromStation.name}
                                        </strong>
                                        <br />
                                        <div style={{ marginTop: "8px" }}></div>
                                        Drop Station:{" "}
                                        <strong>
                                          {booking.toStation.name}
                                        </strong>
                                      </div>
                                      <div className="pickupAndDropTime">
                                        Pickup Time:{" "}
                                        <strong>
                                          {formatTime(
                                            booking.fromStationDate,
                                            "h:mm A",
                                          )}
                                        </strong>
                                        <br />
                                        <div style={{ marginTop: "8px" }}></div>
                                        Drop Time:{" "}
                                        <strong>
                                          {formatTime(
                                            booking.toStationDate,
                                            "h:mm A",
                                          )}
                                        </strong>
                                      </div>
                                       
                                      <div className="buttonContainer">
                                        <div className="callBtnContainer">
                                          {trip.startTime + 14400000 >
                                            Date.now() && (
                                            <div
                                              className="callBtn"
                                              onClick={() =>
                                                this.handleDial(
                                                  booking.mobileNo,
                                                )
                                              }
                                            >
                                              <img
                                                src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/callIcon.svg"
                                                alt="call"
                                              />
                                              Call
                                            </div>
                                          )}
                                        </div>
                                        <div
                                          className={`trackBus ${isTrackBusLoading ? "disabled" : ""}`}
                                          onClick={() =>
                                            this.handleTrackBusClick(booking)
                                          }
                                        >
                                          <img
                                            src="https://d1flzashw70bti.cloudfront.net/original/images/trackBus.svg"
                                            alt="track"
                                          />
                                          <span>Track</span>
                                        </div>
                                        <div
                                          className="serviceViewButton"
                                          onClick={() =>
                                            this.toggleDetails(
                                              booking.connectingBookingCode,
                                            )
                                          }
                                        >
                                          <span>
                                            {expandedBookings[
                                              booking.connectingBookingCode
                                            ]
                                              ? "Hide"
                                              : "Details"}
                                          </span>

                                          <img
                                            src={
                                              expandedBookings[
                                                booking.connectingBookingCode
                                              ]
                                                ? "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrow.svg"
                                                : "https://d1flzashw70bti.cloudfront.net/original/images/tracer/arrowView.svg"
                                            }
                                            alt="toggleArrow"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="expandedRow">
                                      {expandedBookings[
                                        booking.connectingBookingCode
                                      ] &&
                                        coreServiceNames[
                                          booking.connectingBookingCode
                                        ] && (
                                          <div className="items">
                                            <div className="serviceNameDetails">
                                              <span>
                                                PNR:{" "}
                                                <b>
                                                  {
                                                    coreServiceNames[
                                                      booking
                                                        .connectingBookingCode
                                                    ].coreLegPnr
                                                  }
                                                </b>
                                              </span>
                                              <img
                                                src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                                                alt="copy"
                                                className="copyIcon"
                                                onClick={() =>
                                                  this.copyToClipboard(
                                                    coreServiceNames[
                                                      booking
                                                        .connectingBookingCode
                                                    ].coreLegPnr,
                                                  )
                                                }
                                              />
                                            </div>
                                            <div className="serviceNameDetails">
                                              <span>
                                                Service:{" "}
                                                <b>
                                                  {
                                                    coreServiceNames[
                                                      booking
                                                        .connectingBookingCode
                                                    ]
                                                      .connectingBookingServiceName
                                                  }
                                                </b>
                                              </span>
                                              <img
                                                src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/copyicon.svg"
                                                alt="copy"
                                                className="copyIcon"
                                                onClick={() =>
                                                  this.copyToClipboard(
                                                    coreServiceNames[
                                                      booking
                                                        .connectingBookingCode
                                                    ]
                                                      .connectingBookingServiceName,
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                ))}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}

export default TripTable;
